module.exports = __webpack_public_path__ + "img/company2.98289619.png";